import React, { useMemo } from "react";
import {
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from "@stripe/react-stripe-js";

import useResponsiveFontSize from "./useResponsiveFontSize";

import { Grid } from "@material-ui/core";

const useOptions = () => {
  const fontSize = useResponsiveFontSize();
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize,
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: "Source Code Pro, monospace",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#9e2146",
        },
      },
    }),
    [fontSize]
  );

  return options;
};

const SplitForm = () => {
  const options = useOptions();

  return (
    <div>
      <label>
        Card number
        <CardNumberElement
          options={options}
          id="cardNumber"
          // onReady={() => {
          //   console.log("CardNumberElement [ready]");
          // }}
          // onChange={(event) => {
          //   console.log("CardNumberElement [change]", event);
          // }}
          // onBlur={() => {
          //   console.log("CardNumberElement [blur]");
          // }}
          // onFocus={() => {
          //   console.log("CardNumberElement [focus]");
          // }}
        />
      </label>
      <Grid container>
        <Grid item xs={6} sm={6} style={{ paddingRight: 8 }}>
          <label>
            Expiration date
            <CardExpiryElement
              options={options}
              id="cardExpiry"
              // onReady={() => {
              //   console.log("CardNumberElement [ready]");
              // }}
              // onChange={(event) => {
              //   console.log("CardNumberElement [change]", event);
              // }}
              // onBlur={() => {
              //   console.log("CardNumberElement [blur]");
              // }}
              // onFocus={() => {
              //   console.log("CardNumberElement [focus]");
              // }}
            />
          </label>
        </Grid>
        <Grid item xs={6} sm={6} style={{ paddingLeft: 8 }}>
          <label>
            CVC
            <CardCvcElement
              options={options}
              id="cardCVC"
              // onReady={() => {
              //   console.log("CardNumberElement [ready]");
              // }}
              // onChange={(event) => {
              //   console.log("CardNumberElement [change]", event);
              // }}
              // onBlur={() => {
              //   console.log("CardNumberElement [blur]");
              // }}
              // onFocus={() => {
              //   console.log("CardNumberElement [focus]");
              // }}
            />
          </label>
        </Grid>
        <p
          style={{
            fontSize: 12,
            color: "#000000",
            fontWeight: 600,
            marginTop: 0,
            marginBottom: 8,
          }}
        >
          Your credit card will be automatically charged at the end of the trial
          period
        </p>
      </Grid>
    </div>
  );
};

export default SplitForm;
